import { useState } from 'react';
import { Button, Dialog, Typography } from '@optimus-web/core';
import { lt, showSuccessAlert } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { useCurrentEnterpriseId } from '@mews-commander/core';

interface Params {
    rateGroupId: string;
    handleCloseSidePanel?: () => void;
}

export const useDeleteRateGroupConfirmationDialog = ({ handleCloseSidePanel, rateGroupId }: Params) => {
    const enterpriseId = useCurrentEnterpriseId();
    const [isDialogActive, setIsDialogActive] = useState(false);

    const handleClose = () => {
        setIsDialogActive(false);
    };

    const handleConfirm = () => {
        mutate({ enterpriseIds: [enterpriseId], rateGroupIds: [rateGroupId] });
    };

    const { mutate, isPending } = useRepositoryMutation('rateGroups', 'delete', {
        invalidateQueries: { rateGroups: ['getOverviewEntries'] },
        onSuccess: () => {
            handleCloseSidePanel?.();
            showSuccessAlert({ title: lt('DeleteRateGroupSuccessMessage') });
        },
        onSettled: handleClose,
    });

    const confirmationDialog = (
        <Dialog
            active={isDialogActive}
            footer={{
                primary: (
                    <Button onClick={handleConfirm} variant="destructive" type="submit">
                        {lt('Delete')}
                    </Button>
                ),
                secondary: (
                    <Button onClick={handleClose} type="submit">
                        {lt('GoBack')}
                    </Button>
                ),
            }}
            loading={isPending}
            onClose={handleClose}
            size="small"
            title={lt('DeleteRateGroupConfirmationDialogTitle')}
        >
            <Typography textStyle="bodyLarge" as="div">
                {lt('DeleteRateGroupConfirmationDialogDescription')}
            </Typography>
        </Dialog>
    );

    return {
        openConfirmationDialog: () => setIsDialogActive(true),
        confirmationDialog,
    };
};
